export const catBreeds = [
    "Abyssinian",
    "Aegean cat",
    "Australian Mist",
    "American Polydactyl",
    "American Bobtail",
    "American Curl",
    "American Longhair",
    "American Shorthair",
    "American Wirehair",
    "Asian Semi-longhair",
    "Balinese",
    "Bengal",
    "Birman",
    "Bombay",
    "Brazilian Shorthair",
    "British Shorthair",
    "British Longhair",
    "Burmese",
    "Burmilla",
    "California Spangled Cat",
    "Chantilly/Tiffany",
    "Chartreux",
    "Chausie",
    "Cheetoh",
    "Colorpoint Shorthair",
    "Cornish Rex",
    "Cymric",
    "Devon Rex",
    "Donskoy or Don Sphynx",
    "Dragon Li",
    "Egyptian Mau",
    "European Shorthair",
    "Exotic Shorthair",
    "German Rex",
    "Havana Brown",
    "Himalayan/Colorpoint Persian",
    "Japanese Bobtail",
    "Javanese",
    "Korat",
    "Kurilian Bobtail",
    "LaPerm",
    "Maine Coon",
    "Manx",
    "Munchkin",
    "Nebelung",
    "Norwegian Forest Cat",
    "Ocicat",
    "Ojos Azules",
    "Oregon Rex",
    "Oriental Bicolour",
    "Oriental Shorthair",
    "Oriental Longhair",
    "Persian",
    "Peterbald",
    "Pixie-bob",
    "Ragamuffin",
    "Ragdoll",
    "Russian Blue",
    "Russian White, Black and Tabby",
    "Savannah",
    "Scottish Fold",
    "Selkirk Rex",
    "Serengeti cat",
    "Siamese",
    "Siberian",
    "Singapura",
    "Snowshoe",
    "Sokoke",
    "Somali",
    "Sphynx",
    "Sumxu",
    "Thai/Old-style Siamese",
    "Tonkinese",
    "Toyger",
    "Turkish Angora",
    "Turkish Van",
    "Turkish Vankedisi",
    "Twisty Cat/Squitten",
    "Ukrainian Levkoy",
    "Ussuri",
    "York Chocolate Cat"
];